<template>
    <div class="absolute w-full top-24 left-0 z-0">
        <div class="relative w-full aspect-w-1 aspect-h-1 overflow-hidden">
            <div>
                <div class="container relative h-full">
                    <div
                        class="absolute w-[130%] h-[130%] top-0 left-[75%] -translate-x-1/2 bg-contain bg-left-top bg-no-repeat opacity-50"
                        :style="`background-image: url(${require('assets/images/shapes/shape-6_gray-100.png')})`"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TopLocationBackgroundShape1',
};
</script>

<style scoped></style>
